import { Dispatch } from 'react';
import {
  Claim,
  DrivingConviction,
  InsuranceJourneyAdditionalDriverDetailsType,
  MedicalCondition
} from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';
import { initialInsuranceJourneyState } from '../../../consts/Common';

export const AdditionalDriverDetailsPageEventHandlers = (
  additionalDriverDetails: InsuranceJourneyAdditionalDriverDetailsType,
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    onSelectChange: (value: string, key: string) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: { ...additionalDriverDetails, [key]: value }
      });
    },

    onChangeGenderSelection: (value: string) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: { ...additionalDriverDetails, gender: value }
      });
    },

    onChangeFirstName: (
      e:
        | React.FormEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,
          firstName: e.currentTarget.value
        }
      });
    },

    onChangeLastName: (
      e:
        | React.FormEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,
          lastName: e.currentTarget.value
        }
      });
    },

    onChangeDateOfBirth: (value: Date | undefined) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,
          dateOfBirth: value
        }
      });
    },

    onChangeResidentSinceBirth: (value: boolean): void => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,
          residentSinceBirth: value
        }
      });
    },

    onChangeResidentSinceDate: (value: Date | undefined): void => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,
          residentSinceDate: value
        }
      });
    },

    onChangeOccupation: (value: string, key?: string) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,
          occupation: value,
          occupationKey: key
        }
      });
    },

    onChangeIndustry: (value: string, key?: string) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,
          industry: value,
          industryKey: key
        }
      });
    },

    onUpdateClaims: (claims: Claim[]) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,
          claims: [...claims]
        }
      });
    },

    onUpdateDrivingConvictions: (convictions: DrivingConviction[]) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,
          drivingConvictions: [...convictions]
        }
      });
    },

    onUpdateMedicalConditions: (medicalConditions: MedicalCondition[]) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,
          medicalConditions: [...medicalConditions]
        }
      });
    },

    onChangeHadMedicalConditionOrDisabilities: (value: boolean) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails:
          value === false
            ? {
                ...additionalDriverDetails,
                hadMedicalConditionOrDisabilities: value,
                medicalConditions:
                  initialInsuranceJourneyState.additionalDriverDetails
                    .medicalConditions
              }
            : {
                ...additionalDriverDetails,
                hadMedicalConditionOrDisabilities: value
              }
      });
    },

    onChangeDeclinedInsurance: (value: boolean) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,
          declinedInsurance: value
        }
      });
    },

    onChangeHadDrivingConvictions: (value: boolean) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails:
          value === false
            ? {
                ...additionalDriverDetails,
                hadDrivingConvictions: value,
                drivingConvictions:
                  initialInsuranceJourneyState.additionalDriverDetails
                    .drivingConvictions
              }
            : {
                ...additionalDriverDetails,
                hadDrivingConvictions: value
              }
      });
    },

    onChangeNonMotoringConvictions: (value: boolean) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,
          nonMotoringConvictions: value
        }
      });
    },

    onChangeYearsLicenceHeld: (value: string) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails: {
          ...additionalDriverDetails,

          yearsLicenceHeld: value
        }
      });
    },

    onChangeHadClaimAccidentLosses: (value: boolean) => {
      dispatch({
        type: 'set-additionl-driver-details',
        additionalDriverDetails:
          value === false
            ? {
                ...additionalDriverDetails,
                hadClaimAccidentLosses: value,
                claims:
                  initialInsuranceJourneyState.additionalDriverDetails.claims
              }
            : {
                ...additionalDriverDetails,
                hadClaimAccidentLosses: value
              }
      });
    }
  };
};
